import { z } from 'zod/v4';

import { requestDataSchema as LoginDataSchema, verificationRequiredDataSchema } from '@/apis/server/auth/v1/login/validation';
import { requestDataSchema as VerifyOtpSchema } from '@/apis/server/auth/v1/verify-login-otp/validation';

export const requestDataSchema = z.object({
  ...LoginDataSchema.shape,
  ...VerifyOtpSchema.shape,
  mobile: verificationRequiredDataSchema.shape.mobile_number,
  reset_after: verificationRequiredDataSchema.shape.reset_after,
});
